<script setup lang="ts">
defineExpose({
  name: 'homePageSkeleton',
});
</script>

<template>
  <div class="homePageSkeleton">
    <!-- License Status Skeleton -->
    <div class="homePageSkeleton__licenseStatusSkeleton">
      <div class="homePageSkeleton__statusMainHeader shimmer"></div>

      <div class="homePageSkeleton__statusInnerDiv">
        <div
          class="homePageSkeleton__statusInner"
          v-for="itemCount in 3"
          :key="'statusInner-' + itemCount"
        >
          <div class="homePageSkeleton__statusHeader shimmer"></div>
          <div class="homePageSkeleton__statusBar shimmer"></div>
        </div>
      </div>

      <div class="homePageSkeleton__buttonDiv">
        <div
          class="homePageSkeleton__button shimmer"
          v-for="buttonCount in 2"
          :key="'button-' + buttonCount"
        ></div>
      </div>
    </div>

    <!-- Card Skeleton -->
    <div class="homePageSkeleton__CardSkeleton">
      <div class="homePageSkeleton__mainHeader shimmer"></div>

      <div class="homePageSkeleton__inner">
        <div class="homePageSkeleton__header shimmer"></div>

        <div
          class="homePageSkeleton__innerDiv"
          v-for="group in 2"
          :key="'group-' + group"
        >
          <div
            class="homePageSkeleton__inner"
            v-for="item in 2"
            :key="'item-' + group + '-' + item"
          >
            <div class="homePageSkeleton__header shimmer"></div>
            <div class="homePageSkeleton__bar shimmer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_pageForward.scss' as *;

.homePageSkeleton {
  position: relative;
  margin-top: $service-unit * 3;

  &__licenseStatusSkeleton {
    background-color: $color-white-100;
    box-shadow: $service-shadow-mp;
    padding: $service-unit * 3;
    border-radius: $service-border-radius * 2;
    overflow: hidden;
    width: 100%;
  }

  &__statusMainHeader,
  &__statusHeader {
    height: $service-unit * 6;
    background-color: $color-gray-20;
    border-radius: $service-border-radius * 2;
  }

  &__statusMainHeader {
    width: 100% * calc(50 / 150);
    margin: $service-unit * 2;
  }

  &__statusHeader {
    width: 100% * calc(50 / 100);
  }

  &__statusInnerDiv {
    display: flex;
    flex-direction: row;
  }

  &__statusInner {
    padding: $service-unit * 3;
    width: 100%;
  }

  &__statusBar {
    height: $service-unit * 4;
    background-color: $color-gray-20;
    border-radius: $service-border-radius * 2;
    margin-top: $service-unit * 2;
    width: 100% * calc(50 / 200);
  }

  &__buttonDiv {
    display: flex;
    flex-direction: row;
    gap: $service-unit * 3;
    margin-left: $service-unit * 2;
  }

  &__button {
    width: 100% * calc(50 / 316);
    height: $service-unit * 8;
    margin-top: $service-unit * 3;
    background-color: $color-gray-20;
    border-radius: $service-border-radius * 2;
  }

  &__CardSkeleton {
    margin-top: $service-unit * 3;
    background-color: $color-white-100;
    box-shadow: $service-shadow-mp;
    border-radius: $service-border-radius * 2;
    overflow: hidden;
  }

  &__mainHeader,
  &__header {
    height: $service-unit * 6;
    background-color: $color-gray-20;
    border-radius: $service-border-radius * 2;
  }

  &__header {
    width: 25%;
  }

  &__innerDiv {
    display: flex;
    flex-direction: row;
  }

  &__inner {
    padding: $service-unit * 3;
    width: 100%;
  }

  &__bar {
    height: $service-unit * 4;
    background-color: $color-gray-20;
    border-radius: $service-border-radius * 2;
    margin-top: $service-unit * 2;
  }

  &__button {
    height: $service-unit * 8;
    margin-top: $service-unit * 3;
    background-color: $color-gray-20;
    border-radius: $service-border-radius * 2;
  }
}
</style>
